<tui-root [attr.tuiTheme]="theme$()">
    <router-outlet></router-outlet>
</tui-root>
